module.exports = __webpack_public_path__ + "static/media/Overbite (deep bite)7.d3fd5f00.png";